import { Base } from "@app/controllers/base";

// Connects to data-controller="store--countdown"
export default class extends Base {
  static targets = ["display", "bar"]
  static values = { seconds: Number, status: String, expireUrl: String }

  connect() {
    console.log("URL Expire on Countdown:", this.expireUrlValue);
    if (this.statusValue === "paid") {
      this.displayTarget.textContent = "00:00:00"
      this.displayTarget.classList.add("text-emerald")
      this.barTarget.style.width = "100%"
      this.barTarget.classList.replace("bg-gold", "bg-emerald")
      return
    }
    
    this.remaining = this.secondsValue
    this.totalSeconds = this.secondsValue
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    if (this.remaining <= 0) {
      clearInterval(this.timer)
      this.displayTarget.textContent = "00:00:00"
      this.displayTarget.classList.add("text-rose")
      this.barTarget.style.width = "0%"
      this.barTarget.classList.replace("bg-gold", "bg-rose")

      if (this.statusValue === "pending" || this.statusValue === "awaiting_payment") {
        console.log("time off! Redirecting to:", this.expireUrlValue);
        window.location.href = this.expireUrlValue;
      }
      return
    }

    const h = Math.floor(this.remaining / 3600)
    const m = Math.floor((this.remaining % 3600) / 60)
    const s = this.remaining % 60

    this.displayTarget.textContent = `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`

    const pct = Math.max(0, (this.remaining / this.totalSeconds) * 100)
    this.barTarget.style.width = `${pct}%`

    // Turn red when under 1 hour
    if (this.remaining < 300) {
      this.barTarget.classList.replace("bg-gold", "bg-rose")
      this.displayTarget.classList.add("text-rose")
    }

    this.remaining--
  }

  pad(n) {
    return String(n).padStart(2, "0")
  }
}
